// ------ Declare Constants Here --------//

// export var BASE_URL = 'http://54.153.30.36:8071/api/v1/'; // Production AWS
export var BASE_URL = 'https://api.mobihealthcare.net/api/v1/'
// export var BASE_URL = 'http://13.56.63.154:8071/api/v1/'; //UAT
// export var BASE_URL = 'http://52.53.160.193:8071/api/v1/'; // Production AWS
// export var BASE_URL = 'http://172.24.2.20:8071/api/v1/'; // Dev 
// export var BASE_URL = 'http://192.168.2.130:8072/api/v1/'; // local sajid
//export var BASE_URL = 'http://192.168.2.23:8072/api/v1/'; // local Puspa
//export var BASE_URL = 'http://192.168.2.23:8073/api/v1/'; // local Puspa
//export var BASE_URL = 'http://192.168.1.227:8071/api/v1/'; // Private IP
//export var BASE_URL = 'http://202.153.43.139:8071/api/v1/'; // Production
//export var BASE_URL = 'http://202.153.43.139:8080/api/v1/'; //Testing
//export var BASE_URL = 'http://192.168.2.23:8073/api/v1/'; //Testing local
//export var BASE_URL = 'http://202.153.43.139:8080/api/v1/'; //Testing QA Currently working

// export var BASE_URL = 'http://192.168.2.59:8071/api/v1/'

export var API_KEY = '';
export var API_GET = 'GET';
export var API_POST = 'POST';
export var API_PUT = 'PUT';
export var API_DELETE = 'DELETE';



//tickets
export var TICKETS_List = 'public/tickets/find/all/get';
export var TICKETS_CONVERSTION = 'public/conversation/find/get';
export var TICKETS_CONVERSTION_REPLY = 'public/conversation/create';
export var TICKETS_STAUTS = 'public/tickets/update';
export var OTP_VERIFY = '/public/patients/verify/otp';

//-------  DECLARE ENDPOINTS HERE  --------//
export var LOGIN = 'public/user/login';

//triggerOTp 
export var TRIGGER_OTP = 'public/patients/generate/otp';

// export var LOGIN = 'public/user/dashboard/login';
export var FORGOT_USER_NAME = 'public/users/forgot/username/0';
export var FORGOT_PASSWORD = 'public/users/reset/password/link';
export var CHANGE_PASSWORD = 'public/users/reset/password/';

// To get user selected Security Questions previously
export var GET_SECURITY_QUESTION = 'public/users/get/security/question/';

// To verify the answers of User selected Security questions.
export var VERIFY_SECURITY = 'public/users/verify/security/answer';

// Registration Profile update - with out access token
export var REGISTRATION_PROFILE_UPDATE = 'public/patients/update/profile';

// profile update - with access token
export var PROFILE_UPDATE = 'secure/users/update/';
export var PASS_VERIFICATION = 'secure/users/verify/password/';

// To get all Security Questions
export var GET_ALL_SECURITY_QUESTIONS = 'public/questions/find/all/security';
//export var UPDATE_QUESTIONS = 'secure/users/security/question/update';
//To get all random security questions by id
export var GET_ALL_RANDOM_SECURITY_QUESTIONS = 'public/users/get/random/security/question/';
// To update user selected Security Questions
export var UPDATE_SECURITY_QUESTIONS = 'secure/users/security/question/update';

export var DASHBOARD_DETAILS = 'secure/reports/counts';
export var NOTIFICATIONS_DETAILS = 'secure/reports/notifications';
export var QUESTIONNAIRE_DETAILS = 'secure/questions/find/all/type';

// need to remove, will be deprecated. now using "GET_FACILITIES_BY_SEARCH" api instead of this.
export var GET_ALL_FACILITY = 'secure/facilities/find/all';

export var CREATE_FACILITY = 'secure/facilities/create';
export var ANSERTYPE_DETAILS = 'public/questions/all/Answer/type';
export var CREATE_UNIQUE = 'secure/questions/unique/create';
export var UPDATE_FACILITY = 'secure/facilities/update';
export var GET_FACILITY_BY_ID = 'secure/facilities/get/';
export var DEACTIVATE_FACILITY = 'secure/facilities/update/status/';
export var ADD_FACILITY_ADMIN = 'public/users/create';
export var GET_ADMIN_USER_BY_ID = 'secure/users/get/';
export var ACTIVATE_FACILITY_ADMIN = 'secure/users/activate';
export var DEACTIVATE_FACILITY_ADMIN = 'secure/users/deactivation';
export var QUESTIONS_UPDATE = 'secure/questions/update/to/survey';

// Image URl to upload
//export var FACILITY_IMAGE_UPLOAD = 'public/users/add/image'; // old
export var FACILITY_IMAGE_UPLOAD = 'public/users/upload/image';
export var USER_PROFILE_IMAGE = 'public/users/upload/image';
// Image URls to download
let image_Dev = 'http://s3-us-west-1.amazonaws.com/ucdavis-dev/';
let image_Prod = 'http://s3-us-west-1.amazonaws.com/ucdavis-prod/';
export var DownloadImageURL = image_Prod;

export var DELETEUNIQUEQS = 'secure/questions/unique/delete/';

// Registration
export var GET_HEIGHEST_DEGREES = 'public/qualifications/get';
export var GET_PROFESSIONAL_ROLES = 'public/professionalRole/get';
export var GET_ETHNICITIES = 'public/ethnicity/get';

//Admin
// deprecated need to remove
export var GET_ALL_PATIENTS_DATA = 'secure/admin/patients/';
// deprecated need to remove
export var GET_ALL_STAFF_DATA = 'secure/admin/staff/';

// Admin
export var GET_USERS_BY_ROLE = 'secure/admin/users/find/byrole/search';

export var ADMIN_DASHBOARD = 'secure/reports/counts/admin/';

export var ADMIN_SELECT = 'secure/facilities/get/admins/';
export var ADMIN_REQUEST_TO_DEACTIVATE = 'secure/users/deactivate';


export var GET_PATIENT_INFO = 'secure/patients/patientInfo/';
export var GET_SURVEY_LIST = 'secure/users/survey/get';
export var UPDATE_STATUS_STAFF_PATIENT = 'secure/users/update/status';
export var GET_PSYCHIATRIST_LIST = "secure/users/doctor/3/"; // send facilityId & ROLEID: 3-Psychiatrist Support Staff OR 4-Therapist,
export var GET_THERAPIST_LIST = "secure/users/doctor/4/";
export var USER_TRIGGER_TIME = "secure/users/update/tiggertime";
export var REDFLAG = "secure/patients/flags/get/";
//facility search api
// export var GET_FACILITIES_BY_SEARCH = 'secure/facilities/search/bychar'; // Deprecated
//facility search api
export var GET_FACILITIES_BY_SEARCH = 'secure/facilities/find/all/search'
export var UPLOAD_PATIENTS_REGISTRATION_CSV = 'secure/upload/patients';
export var UPLOAD_STAFF_REGISTRATION_CSV = 'secure/upload/staff';

// patient filter
export var FILLTER_PATIENT_BY_DR = 'secure/admin/patients/filter/';
export var PATIENTS_SURVEY_RESPONSE = 'secure/patients/surveyresponse/get/';


// Reports
export var REPORT_SELF_CARE = 'secure/patient/summary/mySelfCare/';
export var REPORT_MYTHOUGHTS = 'secure/patient/summary/mythoughts/';
export var REPORT_MYACTIVITY = 'secure/patient/summary/myActivity/';
export var REPORT_MYEXPERIENCE = 'secure/patient/summary/myexperience/';
// CSV reports -- need to change public to secure
export var CSV_REPORT_ADMIN = 'public/report/admin/'; //admincsvReport
export var CSV_REPORT_SUPER_ADMIN = 'public/report/superadmin/'; //superAdminCsvReport

export var ACTIVE_FACILITY = 'secure/facilities/find/all/active'; //superAdminCsvReport

// ADD QUESTIONS TO SURVEY

//export var ADDQUESTIONSTOSURVEY = 'secure/questions/add/to/patient/survey'; //superAdminCsvReport -- updated as per Sahoo inputs
export var ADDQUESTIONSTOSURVEY = 'secure/patients/unique/questions/link/remove/for/survey'; // PATIENT SURVEY RESPONSE

export var ADMIN_UNIQUE_QUESTION_ALL = 'secure/patients/uniquequestions/get/'; // ADMIN GET ALL UNIQUE QUESTIONS

export var USER_LOG_OUT = 'secure/user/logout';

export var USER_AUTO_LOG_OUT = 'public/user/auto/logout';
export var RESEND_EXPIRED_LINK = 'secure/resendlink/';
export var MULTI_FACILITY_REQUEST = 'public/users/confirm/facility/';
export var USER_REDFLAG_RESLOVE = 'secure/patients/flags/resolve/';
export var VERIFY_OTP = 'public/patients/verify/otp';

export var GET_SECURE_REASON = 'secure/reasons';
export var PUT_SECURE_REASON = 'secure/patients';
export var GET_LOGS = 'secure/patients/flags';
export var POST_LOG = 'secure/patients/';
export var HISTORY_LOGS = 'secure/patients/flags'

export var VERIFY_OTP_PROFILE = '/public/patients/verify/otp';
export var EXPORT_DATA = 'public/tickets/export';

export var WEEKLY_SURVEY_UPDATE = 'secure/questions/update'
//Delete User
export var USER_DELETE = 'user/deleteUser';

export var RESOLVED_REDFLAG_ACTION = '/secure/patients';

//--------- RETURN FINAL URLS -------------//
export var get = (url, data) => {

    switch (url) {
        case RESEND_EXPIRED_LINK: {
            return BASE_URL + RESEND_EXPIRED_LINK;
        }; break;
        case VERIFY_OTP: {
            return BASE_URL + VERIFY_OTP
        };
            break;
        case EXPORT_DATA: {
            return BASE_URL + EXPORT_DATA
        }; break;
        //tickets
        case TICKETS_List: {
            return BASE_URL + TICKETS_List
        };
            break;
        //otp
        case TRIGGER_OTP: {
            return BASE_URL + TRIGGER_OTP;
        }; break;
        case TICKETS_CONVERSTION: {
            return BASE_URL + TICKETS_CONVERSTION;
        };
            break;
        case TICKETS_CONVERSTION_REPLY: {
            return BASE_URL + TICKETS_CONVERSTION_REPLY;
        };
            break;
        case TICKETS_STAUTS: {
            return BASE_URL + TICKETS_STAUTS;
        };
            break;
        case OTP_VERIFY: {
            return BASE_URL + OTP_VERIFY;
        };
            break;
        case LOGIN: {
            return BASE_URL + LOGIN;
        };
            break;
        case FORGOT_USER_NAME: {
            return BASE_URL + FORGOT_USER_NAME;
        }
            break;
        case FORGOT_PASSWORD: {
            return BASE_URL + FORGOT_PASSWORD;
        }
            break;
        case GET_ALL_SECURITY_QUESTIONS: {
            return BASE_URL + GET_ALL_SECURITY_QUESTIONS;
        }
            break;
        // case UPDATE_QUESTIONS: {
        //     return BASE_URL + UPDATE_QUESTIONS;
        // }
        //     break;
        case GET_ALL_RANDOM_SECURITY_QUESTIONS: {
            return BASE_URL + GET_ALL_RANDOM_SECURITY_QUESTIONS;
        }
            break;
        case GET_SECURITY_QUESTION: {
            return BASE_URL + GET_SECURITY_QUESTION;
        }
            break;
        case UPDATE_SECURITY_QUESTIONS: {
            return BASE_URL + UPDATE_SECURITY_QUESTIONS;
        }
            break;
        case CHANGE_PASSWORD: {
            return BASE_URL + CHANGE_PASSWORD;
        }
            break;

        case REGISTRATION_PROFILE_UPDATE: {
            return BASE_URL + REGISTRATION_PROFILE_UPDATE;
        }
            break;
        case PROFILE_UPDATE: {
            return BASE_URL + PROFILE_UPDATE;
        }
            break;
        case PASS_VERIFICATION: {
            return BASE_URL + PASS_VERIFICATION;
        }
            break;


        case DASHBOARD_DETAILS: {
            return BASE_URL + DASHBOARD_DETAILS;
        }
            break;
        case NOTIFICATIONS_DETAILS: {
            return BASE_URL + NOTIFICATIONS_DETAILS;
        }
            break;
        case QUESTIONNAIRE_DETAILS: {
            return BASE_URL + QUESTIONNAIRE_DETAILS;
        }
            break;
        case GET_ALL_FACILITY: {
            return BASE_URL + GET_ALL_FACILITY;
        }
            break;
        case CREATE_FACILITY: {
            return BASE_URL + CREATE_FACILITY;
        }
            break;
        case ANSERTYPE_DETAILS: {
            return BASE_URL + ANSERTYPE_DETAILS;
        }
            break;
        case VERIFY_SECURITY: {
            return BASE_URL + VERIFY_SECURITY;
        }
            break;
        case CREATE_UNIQUE: {
            return BASE_URL + CREATE_UNIQUE;
        }
            break;
        case UPDATE_FACILITY: {
            return BASE_URL + UPDATE_FACILITY;
        }
            break;
        case GET_FACILITY_BY_ID: {
            return BASE_URL + GET_FACILITY_BY_ID;
        }
            break;
        case ADD_FACILITY_ADMIN: {
            return BASE_URL + ADD_FACILITY_ADMIN;
        }
            break;
        case GET_ADMIN_USER_BY_ID: {
            return BASE_URL + GET_ADMIN_USER_BY_ID;
        }
            break;
        case QUESTIONS_UPDATE: {
            return BASE_URL + QUESTIONS_UPDATE;
        }
            break;
        case ACTIVATE_FACILITY_ADMIN: {
            return BASE_URL + ACTIVATE_FACILITY_ADMIN;
        }
            break;
        case DEACTIVATE_FACILITY_ADMIN: {
            return BASE_URL + DEACTIVATE_FACILITY_ADMIN;
        }
            break;
        case FACILITY_IMAGE_UPLOAD: {
            return BASE_URL + FACILITY_IMAGE_UPLOAD;
        }
            break;
        case DEACTIVATE_FACILITY: {
            return BASE_URL + DEACTIVATE_FACILITY;
        }
            break;

        case GET_HEIGHEST_DEGREES: {
            return BASE_URL + GET_HEIGHEST_DEGREES;
        }
            break;
        case GET_PROFESSIONAL_ROLES: {
            return BASE_URL + GET_PROFESSIONAL_ROLES;
        }
            break;
        case GET_ETHNICITIES: {
            return BASE_URL + GET_ETHNICITIES;
        }
            break;
        case DELETEUNIQUEQS: {
            return BASE_URL + DELETEUNIQUEQS;
        }
            break;
        //Admin user cases
        case GET_ALL_PATIENTS_DATA: {
            return BASE_URL + GET_ALL_PATIENTS_DATA;
        }
            break;
        case GET_ALL_STAFF_DATA: {
            return BASE_URL + GET_ALL_STAFF_DATA;
        }
            break;
        case GET_USERS_BY_ROLE: {
            return BASE_URL + GET_USERS_BY_ROLE;
        }
            break;
        case ADMIN_DASHBOARD: {
            return BASE_URL + ADMIN_DASHBOARD;
        }
            break;
        case GET_SURVEY_LIST: {
            return BASE_URL + GET_SURVEY_LIST;
        }
            break;
        case GET_PATIENT_INFO: {
            return BASE_URL + GET_PATIENT_INFO;
        }
            break;
        case GET_PSYCHIATRIST_LIST: {
            return BASE_URL + GET_PSYCHIATRIST_LIST;
        }
            break;
        case GET_THERAPIST_LIST: {
            return BASE_URL + GET_THERAPIST_LIST;
        }
            break;

        case ADMIN_SELECT: {
            return BASE_URL + ADMIN_SELECT;
        }
            break;
        case ADMIN_REQUEST_TO_DEACTIVATE: {
            return BASE_URL + ADMIN_REQUEST_TO_DEACTIVATE;
        }
            break;
        case UPDATE_STATUS_STAFF_PATIENT: {
            return BASE_URL + UPDATE_STATUS_STAFF_PATIENT;
        }
            break;
        case GET_FACILITIES_BY_SEARCH: {
            return BASE_URL + GET_FACILITIES_BY_SEARCH;
        }
            break;

        case USER_TRIGGER_TIME: {
            return BASE_URL + USER_TRIGGER_TIME;
        }
            break;
        case REDFLAG: {
            return BASE_URL + REDFLAG;
        }
            break;
        case UPLOAD_PATIENTS_REGISTRATION_CSV: {
            return BASE_URL + UPLOAD_PATIENTS_REGISTRATION_CSV;
        }
            break;
        case UPLOAD_STAFF_REGISTRATION_CSV: {
            return BASE_URL + UPLOAD_STAFF_REGISTRATION_CSV;
        }
            break;
        case FILLTER_PATIENT_BY_DR: {
            return BASE_URL + FILLTER_PATIENT_BY_DR;

        }
            break;
        case REPORT_SELF_CARE: {
            return BASE_URL + REPORT_SELF_CARE;
        }
            break;
        case REPORT_MYTHOUGHTS: {
            return BASE_URL + REPORT_MYTHOUGHTS;
        }
            break;
        case REPORT_MYACTIVITY: {
            return BASE_URL + REPORT_MYACTIVITY;
        }
            break;
        case REPORT_MYEXPERIENCE: {
            return BASE_URL + REPORT_MYEXPERIENCE;
        }
            break;
        case PATIENTS_SURVEY_RESPONSE: {
            return BASE_URL + PATIENTS_SURVEY_RESPONSE;
        }
            break;
        case CSV_REPORT_ADMIN: {
            return BASE_URL + CSV_REPORT_ADMIN;
        }
            break;
        case CSV_REPORT_SUPER_ADMIN: {
            return BASE_URL + CSV_REPORT_SUPER_ADMIN;
        }
            break;
        case ACTIVE_FACILITY: {
            return BASE_URL + ACTIVE_FACILITY;
        }
            break;
        case ADDQUESTIONSTOSURVEY: {
            return BASE_URL + ADDQUESTIONSTOSURVEY;
        }
            break;
        case ADMIN_UNIQUE_QUESTION_ALL: {
            return BASE_URL + ADMIN_UNIQUE_QUESTION_ALL;
        }
            break;
        case USER_LOG_OUT: {
            return BASE_URL + USER_LOG_OUT;
        }
            break;
        case USER_AUTO_LOG_OUT: {
            return BASE_URL + USER_AUTO_LOG_OUT;
        }
            break;
        case MULTI_FACILITY_REQUEST: {
            return BASE_URL + MULTI_FACILITY_REQUEST;
        }
            break;
        case USER_REDFLAG_RESLOVE: {
            return BASE_URL + USER_REDFLAG_RESLOVE;
        }
            break;
        case GET_SECURE_REASON: {
            return BASE_URL + GET_SECURE_REASON;
        }

            break;
        case PUT_SECURE_REASON: {
            return BASE_URL + PUT_SECURE_REASON;
        }
            break;
        case GET_LOGS: {
            return BASE_URL + GET_LOGS
        }
            break;
        case POST_LOG: {
            return BASE_URL + POST_LOG
        }
            break;
        case HISTORY_LOGS: {
            return BASE_URL + HISTORY_LOGS
        }
            break;
        case USER_DELETE: {
            return BASE_URL + USER_DELETE
        }
            break;
        case RESOLVED_REDFLAG_ACTION: {
            return BASE_URL + RESOLVED_REDFLAG_ACTION
        }

            break;
        case WEEKLY_SURVEY_UPDATE: {
            return BASE_URL + WEEKLY_SURVEY_UPDATE
        }

        default:
            break;
    }
    return 'URL Not configured';
};



/** WEBPACK FOOTER **
 ** ./src/config/api_urls.js
 **/